
import React from 'react';
import { FileText } from 'lucide-react';

const Resources: React.FC = () => {
  return (
    <div className="container mx-auto px-6 max-w-6xl min-h-[60vh] flex flex-col items-center justify-center text-center pt-32">
      <div className="w-20 h-20 bg-[var(--accent-blue-soft)] rounded-3xl flex items-center justify-center text-[var(--accent-blue)] mb-8 border border-[var(--accent-blue)]/20 transition-theme">
        <FileText className="w-10 h-10" />
      </div>
      <h1 className="text-4xl font-bold mb-4 text-[var(--text-main)] transition-theme">Resources and Careers</h1>
      <p className="text-[var(--text-muted)] max-w-sm transition-theme">
        Coming soon...
      </p>
    </div>
  );
};

export default Resources;
